<form class="flex h-full flex-col border border-aux-gray-dark bg-white" [formGroup]="filterForm">
  <div class="flex items-center justify-between px-4 py-2">
    <div class="flex items-center">
      <aux-icon name="Checkbox" class="mr-2" />
      <p class="text-lg font-bold">Tasks</p>
    </div>

    <div class="flex">
      <ng-select
        formControlName="trial"
        class="select w-40"
        bindValue="value"
        placeholder="Trial"
        [items]="trialOptions"
        [searchable]="false"
        [appendTo]="'body'"
      />

      <ng-select
        class="select ml-1.5 w-40"
        formControlName="type"
        bindValue="value"
        placeholder="Type"
        [items]="taskTypeOptions"
        [searchable]="false"
        [appendTo]="'body'"
      />
    </div>
  </div>
  @if (
    {
      filteredUserListTasks: (filteredUserListTasks$ | async) || [],
      originalUserListTasks: (originalUserListTasks$ | async) || [],
    };
    as obj
  ) {
    <aux-portfolio-task-list
      class="h-full grow overflow-y-auto"
      [tasks]="obj.filteredUserListTasks"
      [noTasksMessage]="
        !obj.filteredUserListTasks.length && obj.originalUserListTasks.length
          ? noTasksMessages.FILTER
          : noTasksMessages.NO_TASKS
      "
    />
  }
</form>
